export const STATUS = {
  en_attente: { label: 'En attente', cls: 'bg-zinc-100 text-zinc-600 border-zinc-200' },
  alpha: { label: 'Alpha', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  beta: { label: 'Beta', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  final: { label: 'Final', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};

export const HEALTH = {
  gray: { label: 'À démarrer', dot: 'bg-zinc-300' },
  red: { label: 'Sans fichier', dot: 'bg-red-400' },
  amber: { label: 'En cours', dot: 'bg-amber-400' },
  green: { label: 'Complet', dot: 'bg-emerald-500' },
};

export const STAGE_LABEL = { whitebox: 'Maquette blanche', textured_wb: 'Texture calculée', textured: 'Texturé', furnished: 'Meublé & végétalisé' };

export const fmtDate = (d, opts) => {
  if (!d) return '—';
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return d;
  return dt.toLocaleDateString('fr-FR', opts || { day: 'numeric', month: 'short', year: 'numeric' });
};

export const daysSince = (d) => Math.floor((Date.now() - new Date(d).getTime()) / 86400000);

export const fmtMoney = (n) => {
  if (!n || n <= 0) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} M€`;
  if (n >= 1000) return `${Math.round(n / 1000)} k€`;
  return `${Math.round(n)} €`;
};

export const StatusPill = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.en_attente;
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium leading-4 ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const Eyebrow = ({ children, className = '' }) => (
  <p className={`text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--c-gold)] ${className}`}>{children}</p>
);
